import { getDocumentAsync } from 'expo-document-picker'
import * as FileSystem from 'expo-file-system'
import { Platform } from 'react-native'

export type PickedFile = {
  id: string
  data: ArrayBuffer
  mimeType: string
  name: string
}

export async function pickFile({ fileTypes }: { fileTypes: string[] }) {
  const { assets, canceled } = await getDocumentAsync({
    type: fileTypes,
    copyToCacheDirectory: true,
    multiple: false,
  })

  if (canceled || !assets[0]) {
    return null // User canceled
  }

  const { uri, mimeType, name } = assets[0]

  if (!uri || !mimeType || !fileTypes.includes(mimeType)) {
    throw new Error(`${name} is not a valid document type`)
  }

  const id = Math.random().toString(36).substring(2, 15)

  if (Platform.OS === 'web') {
    const response = await fetch(uri)
    const data = await response.arrayBuffer()
    return { data, mimeType, name, id } satisfies PickedFile
  } else {
    // Mobile: convert base64 to ArrayBuffer
    const base64 = await FileSystem.readAsStringAsync(uri, {
      encoding: FileSystem.EncodingType.Base64,
    })

    // Decode base64 to binary string, then to Uint8Array
    const binaryString = atob(base64)
    const bytes = Uint8Array.from(binaryString, (c) => c.charCodeAt(0))
    return { data: bytes.buffer, mimeType, name, id } satisfies PickedFile
  }
}
